// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartApproverMessageStyles } from "@eisinc/Overrides/Widgets/Common/CartApproverMessage";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color } from "@eisinc/XDL/Utilities";
import { css } from "styled-components";

cartApproverMessageStyles.approvingWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        &:empty {
            display: none;
        }
    `,
};

cartApproverMessageStyles.message = {
    size: fontConfig.small.size,
    lineHeight: fontConfig.small.lineHeight,
};

cartApproverMessageStyles.notify = {
    notifyContainerOverrides: css`
        max-width: 100%;
        &:last-child {
            margin-bottom: 0;
        }
    `,
};
